export default __webpack_public_path__ + "static/media/duke.d5ce6789.png";